import request from './api/request'
import utils from '@/utils/index'
import pfile from '@/utils/secretkey/pfile'
import sfile from '@/utils/secretkey/sfile'

var ak = utils.genak()
var ed = utils.re(ak, unescape(pfile)) //秘钥

function decrypt(data) {
  if (data?.ak) {
    let plaintext = utils.rd(data.ak, unescape(sfile))
    let obj = utils.secret(data.ed, plaintext, true)
    return JSON.parse(obj)
  } else {
    return data
  }
}

function inParameter(data) {
  if (data) {
    return { sn: ed, jt: utils.secret(data, ak) }
  } else {
    return data
  }
}

//获取用户信息
export function getUserInfoAPI(data) {
  return request({
    url: '/user-service/user/info',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//校验登录状态
export function checkLoginAPI() {
  return request({
    url: '/shortUrl-service/shortUrl/checkLogin',
    method: 'post',
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
//个人信息悬浮窗
export function getWebUserVipInfoAPI(data) {
  return request({
    url: '/user-service/member/getWebUserVipInfo',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 获取特权
export function getPrivilege(data) {
  return request({
    url: '/user-service/user/getUpgradeInfo',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 获取下载页底部文案
export function getDownPageVipLabel(data) {
  return request({
    url: '/disk-service/file/getDownPageVipLabel',
    method: 'post',
    data,
  }).catch(err => {})
}
export function userMsginfoapi(data) {
  return request({
    url: '/msg-service/userMsg/info',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
export function setPasswordAPI(data) {
  return request({
    url: '/user-service/passport/setPassword',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
export function setPasswordNewAPI(data) {
  return request({
    url: '/user-service/passport/savePassword',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
//绑定手机
export function bindPhoneAPI(data) {
  return request({
    url: '/user-service/user/bindPhone',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
//绑定手机发送短信验证码
export function bindPhoneSendCode(data) {
  return request({
    url: '/user-service/user/bindPhoneSendCode',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
//实名认证
export function realNameAuth(data) {
  return request({
    url: '/user-service/user/realNameAuth',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
export function userMsg(data) {
  return request({
    url: '/msg-service/userMsg/detailsList',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
export function userMsgread(data) {
  return request({
    url: '/msg-service/userMsg/read',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
// 获取二维码信息
export function getAdJumpQrcodeAPI(data) {
  return request({
    url: '/shorturl-service/shorturl/getAdJumpQrcode',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 获取短链原始链接
export function getJumpUrlAPI(data) {
  return request({
    url: '/shorturl-service/shorturl/getJumpUrl',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//上传头像
export function getDirectAvatarUploadLinkAPI(data) {
  return request({
    url: '/disk-service/file/getDirectAvatarUploadLink',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
//分享页短链详情
export function shareDetail(data) {
  return request({
    url: '/shortUrl-service/shortUrl/shareDetail',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 获取举报类型
export function getReasonAPI(data) {
  return request({
    url: '/disk-service/file/getReportReason',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 新文件举报
export function reportGeneralAPI(data) {
  return request({
    url: '/disk-service/file/reportGeneral',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
// 新文件举报
export function getBannersAPI(data) {
  return request({
    url: '/shortUrl-service/shortUrl/getBanners',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
export function appDownUrl() {
  return request({
    url: '/user-service/common/appDownUrl',
    method: 'post',
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
//获取微信跳转链接
export function getAppletSchemeAPI(data) {
  return request({
    url: '/user-service/passport/getAppletScheme',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
//跳转外部链接
export function redirectUrl(data) {
  return request({
    url: '/shorturl-service/shorturl/redirect',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}

//验证当前短链的解锁状态
export function checkUnlock(data) {
  return request({
    url: '/shorturl-service/shorturl/checkshareDetailUnlock',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {
      console.log(err)
    })
}
// web首页动态列表
export function webHome(data) {
  return request({
    url: "/user-service/home/webHome",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}
// 动态详情接口
export function getDynamicDetails(data) {
  return request({
    url: "/user-service/home/getDynamicDetails",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}
// 获取动态设置
export function appDynamicsSwitch(data) {
  return request({
    url: "/user-service/home/appDynamicsSwitch",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}

// 修改动态设置
export function appDynamicsSwitchUpdate(data) {
  return request({
    url: "/user-service/home/appDynamicsSwitchUpdate",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}

// 收藏短链
export function addShortColl(data) {
  return request({
    url: "/disk-service/file/addFileColl",
    method: "post",
    data: inParameter(data),
  }).then((res)=>{
    res.data = decrypt(res.data)
    return res
  }).catch((err) => {
    console.log(err);
  });
}
// 取消短链收藏
export function delShortColl(data) {
  return request({
      url: "/disk-service/file/delFileColl",
      method: "post",
      data: inParameter(data),
  }).then((res)=>{
      res.data = decrypt(res.data)
      return res
  }).catch((err) => {});
}
